<template>

  <div class="wrap">
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
      <el-form :inline="true" :model="filters" ref="filters">
        <!-- <el-form-item prop="name">
        <el-input placeholder="名称" v-model="filters.name" style="min-width: 120px"></el-input>
      </el-form-item> -->
        <el-form-item label="选择品牌" prop="brandid">
          <el-select v-model.trim="filters.brandid" clearable filterable placeholder="请选择品牌(可搜索)">
            <el-option v-for="item in BrandList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="选择分类" prop="cateid">
          <select-tree ref="selectTree" style="width: 300px" :treeList="returnDropList" nodeKey="treeid"
            :defaultData="defaultData" :treeProps="treeProps" @handleNodeClick="selectDrop"></select-tree>
        </el-form-item> -->

        <el-form-item>
          <el-button type="primary" @click="search()">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="showAddDialog">增加</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm('filters')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <zk-table ref="table" :data="data1" :columns="columns" :stripe="props.stripe" :border="props.border"
      :show-header="props.showHeader" :show-summary="props.showSummary" :show-row-hover="props.showRowHover"
      :show-index="props.showIndex" :tree-type="props.treeType" :is-fold="props.isFold" :expand-type="props.expandType"
      :selection-type="props.selectionType" sum-text="sum" index-text="序号">
      <template slot="action" scope="scope">
        <el-button type="text" @click="pre_add(scope.row)">添加
        </el-button>
        <el-button type="text" @click="pre_edit(scope.row)">修改
        </el-button>
        <el-button type="text" v-if="scope.row.children.length <= 0" @click="del(scope.row)">删除
        </el-button>
      </template>
      <template slot="img" scope="scope">
        <div class="demo-image__preview">
          <el-image style="width: 60px; height: 40px" :src="scope.row.url" :preview-src-list="scope.row.urls">
          </el-image>
        </div>
      </template>
      <template slot="nametag" scope="scope">
        <el-tag :type="scope.row.brandid === 1 ? 'primary' : 'success'" disable-transitions>{{
          scope.row.brand
        }}</el-tag>
      </template>
      <template slot="sortid" scope="scope">
        <span class="demonstration">{{ scope.row.sortid }}</span>
      </template>
    </zk-table>

    <!-- 添加界面 -->
    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm" show-overflow-tooltip>
        <el-form-item label="父目录" prop="parentid">
          <el-select v-model="selectTree" :disabled="istree" clearable filterable placeholder="请选择父类">
            <el-option :value="selectTree" :label="selectName" style="height: auto">
              <el-tree :data="treeData" ref="tree" :props="defaultProps" node-key="id" :accordion="true"
                @node-click="handleNodeClick"></el-tree>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属品牌" prop="brandid">
          <el-select v-model.trim="addForm.brandid" :disabled="isshow" clearable filterable placeholder="请选择(可搜索)">
            <el-option v-for="item in BrandList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="addForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="sortid">
          <el-input v-model="addForm.sortid" placeholder="序号越大越靠后"></el-input>
        </el-form-item>
        <el-form-item label="缩略图" prop="picurl">
          <el-upload class="avatar-uploader" action="/mallapi/MallApi/file/upload" :show-file-list="false"
            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
            <img v-if="addForm.picurl" :src="addForm.picurl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div class="el-upload__tip" slot="tip">图片只能是 JPG 格式，且不超过2M</div>
          </el-upload>

        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

  </div>


</template>

<script>
import MallApi from "../../../api/goods/goodscateapi"
import selectTree from '@/components/common/selectTree'
import {
  isInteger
} from "../../../utils/validators";
export default {
  components: {
    selectTree
  },
  data() {
    return {
      //搜索框
      defaultData: {
        treeid: "-1",
        name: '根目录'
      },
      treeProps: {
        children: 'children',
        label: 'name'
      },
      returnDropList: [],


      props: {
        stripe: false,
        border: true,
        showHeader: true,
        showSummary: false,
        showRowHover: true,
        showIndex: true,
        treeType: true,
        isFold: true,
        expandType: false,
        selectionType: false
      },
      columns: [
        { label: "名称", align: "left", prop: "name", tree: true },
        //{ label: "id", align: "left", prop: "id" },
        { label: "品牌", type: "template", template: "nametag", },
        { label: "图片", type: "template", template: "img" },
        { label: "排序", type: "template", template: "sortid" },
        {
          label: "操作",
          align: "center",
          prop: "action",
          template: "action",
          type: "template",
          width: "180px"
        }
      ],
      data1: [],
      filters: {
        cateid: "",
        brandid: ""
      },
      BrandList: [{ id: 1, name: "孚日" }, { id: 2, name: "洁玉" }],

      treeData: [],
      select: {},
      treeData: [],
      selectTree: "",
      selectName: "",
      defaultProps: { label: "name", children: "children" },
      isshow: false,
      istree: false,
      loading: false,
      //新增
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [
          { required: true, message: "请输入分类名称", trigger: "blur" },
        ],
        picurl: [
          { required: true, message: "请上传缩略图", trigger: "blur" },
        ],
        parentid: [
          { required: true, message: "请选择父目录", trigger: "blur" },
        ],
        brandid: [
          { required: true, message: "请选择品牌", trigger: "blur" },
        ],
        sortid: [
          { required: true, message: "请输入序号", trigger: "blur" },
          { validator: isInteger },
        ],
      },
      addForm: {
        id: "",
        name: "",
        picurl: "",
        parentid: "",
        brandid: "",
        sortid: 1
      },
    }
  },
  methods: {
    pre_edit(e) {
      this.addFormVisible = true
      this.addForm.name = e.name
      this.addForm.picurl = e.url
      this.addForm.id = e.id
      this.addForm.parentid = e.parentid
      this.addForm.brandid = e.brandid
      this.addForm.sortid = e.sortid
      //目录选中
      this.selectTree = e.parentid
      this.selectName = e.parentname
      this.isshow = true
      this.istree = true

      this.$nextTick(() => {
        //清除验证信息
        this.$refs["addForm"].clearValidate();
      });

    },
    del(e) {
      let that = this;
      this.$confirm("确认删除该记录吗?", "提示", { type: "warning" })
        .then(() => {
          that.loading = true;
          MallApi.delete({ id: e.id })
            .then(
              function (result) {
                that.loading = false;
                if (result && parseInt(result.code) === 0) {
                  that.$message.success({
                    showClose: true,
                    message: "删除成功",
                    duration: 1500,
                  });
                  that.search();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message,
                    duration: 1500,
                  });
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000,
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000,
              });
            });
        })
        .catch(() => { });
    },

    handleNodeClick(data) {
      //树形选择
      this.addForm.parentid = data.id; //给表单数据项赋值
      this.selectTree = data.id;
      this.selectName = data.name; // 框中显示值为label
      if (data.id != -1) {
        this.isshow = true
        this.addForm.brandid = data.brandid
      } else {
        this.isshow = false
        this.addForm.brandid = ""
      }
    },

    Tree() {
      let params = {
        name: null,
        brandid: null
      };
      let that = this;
      MallApi.getCateTree(params).then(function (result) {
        if (result.code == 0) {
          that.treeData = result.data;
          that.returnDropList = result.data
        }
      },
        function (err) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000,
          });
        })
    },
    load() {
      let params = {
        cateid: this.filters.cateid,
        brandid: this.filters.brandid
      };
      let that = this;
      that.loading = true;
      MallApi.getCateList(params).then(function (result) {
        //that.loading = false;
        if (result.code == 0) {
          that.loading = false;
          that.data1 = result.data;
        }
      },
        function (err) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000,
          });
        })
    },
    search() {
      this.load();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.filters.cateid = 0
      this.$refs.selectTree.clearSelect()
    },
    showAddDialog: function () {
      //初始化
      this.addForm = {
        id: "",
        name: "",
        picurl: "",
        parentid: "",
        brandid: "",
      }
      this.selectTree = ""
      this.selectName = ""
      this.isshow = false
      this.istree = false

      this.addFormVisible = true;
      this.$nextTick(() => {
        //清除验证信息
        this.$refs["addForm"].clearValidate();
      });



    },
    addSubmit: function () {
      let that = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          that.addLoading = true;
          MallApi.add(this.addForm).then(function (result) {
            if (0 === result.code) {
              that.addLoading = false;
              that.$message;
              that.$message.success({
                showClose: true,
                message: "操作成功",
                duration: 2000,
              });
              that.$refs["addForm"].resetFields();
              that.addFormVisible = false;
              that.load();
            } else {
              that.$message.error({

                showClose: true,
                message: result.message || "操作失败",
                duration: 2000,
              });
              that.addLoading = false;
            }
          });
        }
      });
    },
    pre_add(e) {
      this.showAddDialog()
      this.addForm.parentid = e.id
      this.selectTree = e.id
      this.selectName = e.name
      this.addForm.brandid = e.brandid
      this.isshow = true
      this.istree = true
      this.$nextTick(() => {
        //清除验证信息
        this.$refs["addForm"].clearValidate();
      });
    },

    //图片上传

    handleAvatarSuccess(res, file) {
      if (res.code === 0) {
        //console.log(res.data)
        this.addForm.picurl = "data:image/jpeg;base64," + res.data
      } else {
        this.$message.error(res.message)
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    //搜索栏分类选中
    selectDrop(data, checked) {
      // console.log(data)
      this.filters.cateid = data
    }
  },
  mounted() {
    this.load();
    this.Tree();
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

<!-- <style lang="less" scoped>
.wrap {
  font-size: 30px;
   /deep/ .zk-table {
      .zk-table__header-wrapper {
        thead {
          .zk-table__header-row {
            height: 48px;
            color: #515a6e;
            font-size: 16px;
            th {
              &:first-child {
                > div {
                  padding-left: 10px;
                }
              }

              &:nth-child(n + 2) {
                > div {
                  padding: 0;
                  // &:not(1){
                  text-align: center;

                  // }
                }
              }
            }
          }
        }
      }
      .zk-table__body-wrapper {
        .zk-table__body {
          tbody {
            .zk-table--empty-row {
              height: 48px;
            }
            .zk-table__body-row {
              font-size: 14px;
              color: #515a6e;
              td {
                > div {
                  span {
                    display: inline-block;
                    height: 40px;
                    // line-height: 40px;
                    display: flex;
                    align-items: center;

                    .zk-table--tree-icon {
                      color: grey;
                      font-size: 16px;

                      // margin-top: 5px;
                    }
                  }
                }
                &:first-child {
                  .zk-table__cell-inner {
                    padding: 6px 6px;
                    .zk-table--level-2-cell {
                      margin-left: 10px !important;
                    }
                    .zk-table--level-3-cell {
                      margin-left: 20px !important;
                    }
                    .zk-table--level-4-cell {
                      margin-left: 30px !important;
                    }
                  }
                }
                &:not(1) {
                  .zk-table__cell-inner {
                    text-align: center;
                    span {
                      margin-left: 0;
                    }
                  }
                }
                &:last-child {
                  > div {
                    padding: 6px 23px;
                    margin: 0 auto;

                    // width: 150px;
                    display: flex;
                    justify-content: flex-end;
                    color: #2d8cf0;
                    span {
                      margin-left: 10px;
                      &:first-child {
                        margin-left: 0;
                      }
                      &:nth-child(odd) {
                        cursor: pointer;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
}
</style> -->

